import { TaxonomyIdItem } from "@amzn/taxonomy-lib";

export const createItemTaxonomy = (id: string) => {
  try {
    const tx = new TaxonomyIdItem(id);
    if (tx) {
      return tx;
    } else {
      throw new Error(`Unable to create taxonomy id with string ${id}.`);
    }
  } catch (e) {
    console.error(`Unable to create taxonomy id with string ${id}. Error: ${e}`);
  }
  return undefined;
};
